import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  set(key: any, data: any) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  get(key: any) {
    let data = localStorage.getItem(key);
    if (data !== null) {
      return JSON.parse(data);
    }
    return null;
  }

  delete(key: any) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}
